// extracted by mini-css-extract-plugin
export default {"tag":"DemoTag_tag__g9LZc","compact":"DemoTag_compact__QAfXf"};